module.exports = __webpack_public_path__ + "7d93907a26b8e5e72f95ac6fe3f31a31.svg";